import { type RouteRecordRaw } from 'vue-router'

export const agentRouter: RouteRecordRaw[] = [
  {
    component: async () => await import('../views/AgentView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel'),
      title: 'agent',
    },
    name: 'brand.agent',
    path: 'agent',
  },
]
